// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/modules/products/v2_0/model/model-print.scss
// module id = 1451
// module chunks = 10